function filterFaq(main, rawQuery) {
  const query = rawQuery.trim().toLowerCase();
  const groups = main.querySelectorAll('[data-rsp-faq-group]');
  let visibleItems = 0;

  groups.forEach((group) => {
    let visibleInGroup = 0;
    group.querySelectorAll('[data-rsp-faq-item]').forEach((item) => {
      const searchText = item.dataset.searchText || '';
      const matches = !query || searchText.includes(query);
      item.hidden = !matches;
      if (matches) visibleInGroup += 1;
    });
    group.hidden = visibleInGroup === 0;
    visibleItems += visibleInGroup;
  });

  const emptyMessage = main.querySelector('[data-rsp-faq-empty]');
  if (emptyMessage) emptyMessage.hidden = visibleItems !== 0;
}

function initFaq() {
  const main = document.querySelector('main[data-template="page.faq"]');
  if (!main || main.dataset.rspFaqReady === 'true') return;
  main.dataset.rspFaqReady = 'true';

  main.addEventListener('input', (event) => {
    if (!(event.target instanceof Element)) return;
    const input = event.target.closest('[data-rsp-faq-search]');
    if (!input) return;
    filterFaq(main, input.value);
  });
}

document.addEventListener('DOMContentLoaded', initFaq);
document.addEventListener('shopify:section:load', initFaq);
